import './styles/ReviewSpinner.scss';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';

/**
 * Review loading indicator.
 *
 * @return {JSX.Element}
 */
const ReviewSpinner = () => {
  return (
    <div className="review-spinner">
      <FontAwesomeIcon icon={faSpinner} spin={true} size="2x"/>
    </div>
  );
};

export default ReviewSpinner;
